export const Size = {
  mobile: 320,
  tablet: 768,
  desktop: 1280
};

export const Min = {
  mobile: `screen and (min-width: ${Size.mobile}px)`,
  tablet: `screen and (min-width: ${Size.tablet}px)`,
  desktop: `screen and (min-width: ${Size.desktop}px)`
};

export const Max = {
  mobile: `screen and (max-width: ${Size.mobile}px)`,
  tablet: `screen and (max-width: ${Size.tablet}px)`,
  desktop: `screen and (max-width: ${Size.desktop}px)`
};

export const MinAndMax = {
  mobile: `screen and (min-width: ${Size.mobile}px) and (max-width: ${Size.tablet - 1}px)`,
  tablet: `screen and (min-width: ${Size.tablet}px) and (max-width: ${Size.desktop - 1}px)`,
  desktop: `${Min.desktop}`
};

export default {
  Size,
  Min,
  Max,
  MinAndMax
};
